import * as Sentry from '@sentry/nextjs';

/**
 * Standardized error categories for Sentry exception reporting
 */
export enum SENTRY_LABEL {
  ANALYTICS = '[ANALYTICS]',
  ACTION = '[ACTION]',
  FETCHING = '[FETCHING]',
  PREFETCH = '[PREFETCH]',
  STORE = '[STORE]',
  AUTH = '[AUTH]',
  VALIDATION = '[VALIDATION]',
  ROUTING = '[ROUTING]',
  RENDER = '[RENDER]',
  API = '[API]',
  GLOBAL = '[GLOBAL ERROR]',
  VITALY = '[VITALY]',
}

/**
 * Helper function to capture typed errors in Sentry with consistent categorization
 *
 * @param label - The error label from SENTRY_LABEL
 * @param message - Error message that describes what happened
 * @param extra - Additional data to attach to the error report
 */
export function captureLabeledSentryError(label: SENTRY_LABEL, message: string, extra?: Record<string, unknown>) {
  const formattedMessage = `${label}:${message}`;
  Sentry.captureException(new Error(formattedMessage), { extra });
}

export function captureLabeledSentryMessage(label: SENTRY_LABEL, message: string, extra?: Record<string, unknown>) {
  const formattedMessage = `${label}:${message}`;
  Sentry.captureMessage(formattedMessage, { extra });
}
